import { useLocation } from "react-router-dom";
import SVG from "../../../Components/SVG";
import { normalizeSymbolCode } from "../tradeUtils";

const TRADE_SYMBOL_QUERY_KEY = "tradeSymbol";
const LEGACY_SYMBOL_QUERY_KEY = "symbol";

export default function AccountSelect({
  options = [],
  defaultValue,
  symbol,
  className = "",
}) {
  const location = useLocation();
  return (
    <div
      className={`relative h-fit inline-flex items-center rounded-lg text-sm gap-2.5 bg-zi-bg2-light dark:bg-zi-bg2-dark text-zi-text-light dark:text-zi-text-dark ring-1 ring-inset ring-zi-border-dark hocus:ring-2 ${className}`}
    >
      <select
        id="accountSelect"
        name="accountSelect"
        value={defaultValue}
        className="w-fit min-w-0 truncate bg-transparent outline-none appearance-none border-none py-2.5 pr-3 pl-9 cursor-pointer"
        onChange={(e) => {
          const selectedOption = options.find(
            (option) => String(option.code) === String(e.target.value),
          );
          if (!selectedOption) return;

          const nextSearchParams = new URLSearchParams(location.search);
          const normalizedSymbol = normalizeSymbolCode(symbol);

          if (normalizedSymbol) {
            nextSearchParams.set(TRADE_SYMBOL_QUERY_KEY, normalizedSymbol);
          } else {
            nextSearchParams.delete(TRADE_SYMBOL_QUERY_KEY);
          }
          nextSearchParams.delete(LEGACY_SYMBOL_QUERY_KEY);

          const nextSearch = nextSearchParams.toString();
          const nextUrl = `/trade/${selectedOption.code}/trade${
            nextSearch ? `?${nextSearch}` : ""
          }`;

          window.location.assign(nextUrl);
        }}
      >
        {options.map((opt, index) => {
          let opt_name = "";
          if (opt.challenge_type === "real") {
            opt_name += "حساب واقعی ";
          } else {
            opt_name += "حساب تمرینی ";
          }
          opt.phase_type === "phase1"
            ? (opt_name += "فاز اول ")
            : opt.phase_type === "phase2"
              ? (opt_name += "فاز دوم ")
              : (opt_name += "فاندد ");
          opt_name += `${opt.challenge_category} | ${opt.challenge_name}`;
          return (
            <option
              key={index}
              value={String(opt.code)}
              className="text-zi-text-light text-xs sm:text-sm"
            >
              {opt_name}
            </option>
          );
        })}
      </select>

      {/* Custom select arrow icon (replaces browser default) */}
      <div className="pointer-events-none absolute left-3 flex items-center">
        <SVG
          name="select"
          classname="size-3 stroke-zi-text-light dark:stroke-zi-text-dark"
        />
      </div>
    </div>
  );
}
